// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"c66dfd49","393":"e0614814","462":"46aef40f","787":"0d5aed7a","905":"7108ea2d","965":"1461191f"}[chunkId] + ".chunk.js";
};